import { EditorComponent } from "ngx-monaco-editor";
import { AlertService } from "@app/services";

// https://github.com/NaturalIntelligence/fast-xml-parser/issues/39
declare var require: any;
var fastXmlParser = require("fast-xml-parser");


// internal class
export class CodeData {
  code: string = '';
  _editor: EditorComponent;
  _errors: any = [];

  editorOptions = {
    theme: 'vs-dark',
    language: 'xml',
    roundedSelection: true,
    autoIndent: true,
    tabSize: 2,
    formatOnType: true,
    automaticLayout: false,
    readOnly: false,
    minimap: {
      // enabled: true,        // default: true
      maxColumn: 60, // default: 120
      //showSlider: "mouseover", // always, mouseover; default: mouseover
      // side: "right",        // left, right; default: right
    },
  };

  editorOptionsReadOnly = {
    theme: 'vs-dark',
    language: 'xml',
    roundedSelection: true,
    autoIndent: true,
    tabSize: 2,
    formatOnType: true,
    automaticLayout: false,
    readOnly: true,
    minimap: {
      maxColumn: 60,
    },
  };

  // xmlOptions = {
  //   attributeNamePrefix: "@_",
  //   attrNodeName: "attr", //default is 'false'
  //   textNodeName: "#text",
  //   ignoreAttributes: true,
  //   ignoreNameSpace: false,
  //   allowBooleanAttributes: false,
  //   parseNodeValue: true,
  //   parseAttributeValue: false,
  //   trimValues: true,
  //   cdataTagName: "__cdata", //default is 'false'
  //   cdataPositionChar: "\\c",
  //   parseTrueNumberOnly: false,
  //   arrayMode: false, //"strict"
  //   //attrValueProcessor: (val, attrName) => he.decode(val, { isAttributeValue: true }), //default is a=>a
  //   //tagValueProcessor: (val, tagName) => he.decode(val), //default is a=>a
  //   stopNodes: ["parse-me-as-string"],
  // };

  constructor(
    private _name: string,
    private lang: string
  ) {
    //this.editorOptions.language = lang;
  }

  get name(): string {
    return this._name;
  }

  set nameValue(name: string) {
    this._name = name;
  }

  set editor(editor: EditorComponent) {
    this._editor = editor;
    monaco.editor.setModelMarkers((this.editor as any)._modelData.model, "owner", this._errors);
    (this._editor as any).trigger("anyString", "editor.action.formatDocument");
  }

  get editor(): EditorComponent {
    return this._editor;
  }

  get readOnly(): boolean {
    return this.editorOptions.readOnly;
  }

  set readOnly(ro: boolean) {
    this.editorOptions.readOnly = ro;
  }

  get langValue(): string {
    return this.lang;
  }

  set langValue(lang: string) {
    this.lang = lang;
    this.editorOptions.language = lang;
    this.editorOptionsReadOnly.language = lang;
  }

  clean() {
    this.code = '';
    this._errors = [];
  }

  cleanErrors() {
    this._errors = [];
  }

  validate(alertService: AlertService): boolean {
    switch (this.editorOptions.language) {
      case 'xml':
        return this.validateXml(alertService);
      // case 'ini':
      // case 'sql'
    }
    return true;
  }

  private validateXml(alertService: AlertService): boolean {
    this.cleanErrors();

    if (this.code != null && this.code.length > 0) {
      var valid = fastXmlParser.validate(this.code);

      if (valid !== true) {
        console.warn(this.name, valid.err);
        this._errors = [
          {
            startLineNumber: valid.err.line,
            startColumn: 1,
            endLineNumber: valid.err.line,
            endColumn: 100,
            message: "Error!",
            severity: monaco.MarkerSeverity.Error,
          },
        ];
        let msg = new String().concat('Erro configuração ', this.name, ': ', valid.err.code, ' na linha ', valid.err.line, ': ', valid.err.msg.replace('<', '&lt;').replace('>', '&gt;'));
        alertService.warn(msg);

        if (this.editor !== undefined && (this.editor as any)._modelData !== undefined && (this.editor as any)._modelData.model !== undefined) {
          monaco.editor.setModelMarkers((this.editor as any)._modelData.model, "owner", this._errors);
          (this.editor as any).trigger("anyString", "editor.action.formatDocument");
        }

        return false;
      }

    }

    return true;
  }

}
